import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=29234469&scoped=true&v-if=lang&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.scss?vue&type=style&index=0&id=29234469&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29234469",
  null
  
)

export default component.exports